import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericDialog } from '@app/shared/models/generic-dialog.model';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';

@Component({
  selector: 'dhl-modal-carry-info-pay-odc',
  templateUrl: './modal-carry-info-pay-odc.component.html',
  styleUrls: ['./modal-carry-info-pay-odc.component.scss']
})
export class ModalCarryInfoPayOdcComponent {
  dialogData: GenericDialog;

  constructor(public dialogRef: MatDialogRef<GenericDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: GenericDialog) {
    this.dialogData = data;
  }

  /**
   * On Accept dialog generic action
   */
  onAccept(): void {
    this.dialogRef.close(true);
  }

  /**
   * On Cancel dialog generic action
   */
  onCancel(): void {
    this.dialogRef.close(false);
  }

}
